/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Box, CircularProgress, Modal, Stack } from '@mui/material';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { Trash2 } from 'lucide-react';
import {
  deleteSpecialAccess,
  deleteUser,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
  getAllCity,
  deleteCity,
  getSmartHomeDeviceByBNB,
  getCityWiseBnB,
  getSmartHomeRoomByBnB,
  createSmartHomeRoom,
  deleteSmartHomeRoom,
  updateSmartHomeRoom,
  getSmartHomeDeviceByBNBWithAccessToken,
} from '../../helper/backend_helper';
import Swal from 'sweetalert2';

// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export default function SmartHomeDevices() {
  const navigate = useNavigate();
  const location = useLocation();

  const bnb = location?.state?.bnb;
  const [open, setOpen] = useState(false);
  const [delRooms, setDelRooms] = useState([]);
  const [roomLoading, setRoomLoading] = useState(false);
  // const handleOpen = () => setOpen(true);
  const handleOpen = async () => {
    setOpen(true);
    const data = {
      bnb,
    };
    const rooms = await getSmartHomeRoomByBnB(data);
    setRooms(rooms?.data?.data);
    setDelRooms([]);
  };
  const handleClose = () => setOpen(false);
  const [rooms, setRooms] = useState([]);
  const [devicesData, setDevicesData] = useState([]);
  console.log(devicesData);
  console.log(delRooms);
  console.log(rooms);
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const getDevices = async () => {
    try {
      setLoading(true);
      const smartDeviceRes = await getSmartHomeDeviceByBNBWithAccessToken(bnb);
      console.log(smartDeviceRes)
      setAccessToken(smartDeviceRes?.data?.data?.accessToken);
      const res = await getSmartHomeDeviceByBNB(bnb);
      setDevicesData(res?.data?.data);
      const data = {
        bnb,
      };
      const rooms = await getSmartHomeRoomByBnB(data);
      setRooms(rooms?.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getDevices();
  }, [bnb]);

  const handleAddRoom = () => {
    setRooms([...rooms, { name: '', italianName: '', bnb: bnb }]);
  };

  const handleRoomChange = (index, field, value) => {
    const updatedRooms = [...rooms];
    updatedRooms[index][field] = value;
    setRooms(updatedRooms);
  };

  // const deleteRoom = (index, id) => {
  //   setRooms(rooms.filter((_, i) => i !== index));
  //   console.log(id);
  //   setDelRooms([...delRooms, id]);
  // };

  const createRoom = async () => {
    try {
      setRoomLoading(true);

      const headers = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      // for (const id of delRooms) {
      //   await deleteSmartHomeRoom(id, headers);
      // }
      setDelRooms([]);
      for (const room of rooms) {
        const data = {
          bnb, // Ensure `bnb` is correctly defined
          italianName: room.italianName,
          name: room.name,
        };
        if (room?._id) {
          const updateRes = await updateSmartHomeRoom(room._id, data, headers);
          console.log(`Room Updated:`, updateRes);
        } else {
          const res = await createSmartHomeRoom(data, headers);
          console.log(`Room Created:`, res);
        }
      }
      setRoomLoading(false);
    } catch (error) {
      setRoomLoading(false);
      console.log(error);
    }
  };


  const handleDelete = async (id) => {
    try {
        await deleteSmartHomeRoom(id);
        const data = {
          bnb,
        };
        const rooms = await getSmartHomeRoomByBnB(data);
        setRooms(rooms?.data?.data);
    } catch (error) {
      setOpen(false);
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: error.response.data.errors[0].detail,
      });
    }
  };

  return (
    <>
      <div className="bg-[#f4f4f4]  p-4">
        <Helmet>
          <title> Smart Home Devices </title>
        </Helmet>

        {/* <Card sx={{ p: 3 }}>
        <Stack mb={3} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">Smart Home Devices</Typography>

          <Button
            sx={{
              boxShadow: 'none',
              backgroundColor: '#1E3A5F',
              '&:hover': {
                backgroundColor: '#1E3A5F',
                boxShadow: 'none',
              },
            }}
            variant="contained"
            endIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => navigate('/smart-homes/add_smart-home')}
          >
            Create New
          </Button>
        </Stack>

        <Scrollbar>
          <Stack mt={2} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Select BnB</FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack>
            {Object.entries(devicesData)?.map(([roomName, devices]) => (
              <Stack key={roomName} mt={3}>
                <Typography variant="h5">{roomName}</Typography>
                {devices.map((device) => (
                  <Typography key={device.deviceName} variant="body1">
                    {device?.shellyDevice?.name || device?.smartThingDevice?.name}
                  </Typography>
                ))}
              </Stack>
            ))}
          </Stack>
        </Scrollbar>
      </Card> */}

        <div className="flex justify-between items-center ">
          <div className="flex items-center gap-4 ">
            <div className="cursor-pointer" onClick={() => navigate(-1)}>
              <FaArrowLeftLong size={28} />
            </div>
            <h1 className="text-3xl font-bold text-black">{bnb}</h1>
          </div>

          <div className="flex items-center gap-5">
            {/* <div onClick={() => navigate(`/smart-homes/add_smart-home`)} className="flex gap-2 cursor-pointer">
              <span className="bg-[#4D56FF] w-52 text-center text-white text-[16px] font-thin   py-1 rounded-2xl dark:bg-blue-900 dark:text-blue-300">
                test
              </span>
            </div> */}
            <div onClick={handleOpen} className="flex gap-2 cursor-pointer">
              <span className="bg-[#4D56FF] w-52 text-center text-white text-[16px] font-thin   py-1 rounded-2xl dark:bg-[#4D56FF] dark:text-white">
                Edit rooms
              </span>
            </div>
            <div  onClick={() => navigate('/createSmartHomeDevice', { state: {  bnb,accessToken } })} className="flex gap-2 cursor-pointer">
              <span className="bg-[#4D56FF] w-52 text-center text-white text-[16px] font-thin   py-1 rounded-2xl dark:bg-[#4D56FF] dark:text-white">
                Add new device
              </span>
            </div>
          </div>
        </div>

        {loading && (
          <div className="flex justify-center items-center h-screen">
            <CircularProgress />
          </div>
        )}

        {Object.entries(devicesData)?.map(([roomName, devices]) => {
          return (
            <>
              <div className="mt-5">
                <h1 className="text-2xl font-medium">{roomName}</h1>
              </div>
              <div className="flex items-center gap-4 flex-wrap">
                {devices?.map((data) => {
                  return (
                    <div onClick={() => navigate('/updateSmartHomeDevice', { state: { bnb,accessToken,data } })} className="bg-white mt-2 rounded-3xl cursor-pointer p-4 w-80 flex flex-col gap-2">
                      <h1 className="text-2xl font-normal text-black">
                        {data?.shellyDevice?.name || data?.smartThingDevice?.name}
                      </h1>

                        <h1 className="text-base font-normal text-black">{data?.deviceName}</h1>
                      <div className="flex justify-start items-center gap-2">
                        <div className="h-3 w-3 bg-green-300 rounded-full" />
                        <h1>Device online</h1>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          );
        })}
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h1 className="text-center text-3xl text-black font-bold">Rooms</h1>

          <div className="w-full mx-auto mt-10">
            <div className="grid grid-cols-3 gap-4 items-center text-center mb-2 font-semibold">
              <span>ENGLISH NAME</span>
              <span>ITALIAN NAME</span>
              <span></span>
            </div>
            <div className="max-h-[50vh] overflow-y-scroll">
              {rooms.map((room, index) => (
                <div key={room._id} className="grid grid-cols-3 gap-4 items-center mb-5">
                  <input
                    type="text"
                    value={room.name}
                    onChange={(e) => handleRoomChange(index, 'name', e.target.value)}
                    //   disabled
                    className="bg-gray-100 px-4 py-2 rounded-full text-center w-full"
                  />
                  <input
                    type="text"
                    value={room.italianName}
                    onChange={(e) => handleRoomChange(index, 'italianName', e.target.value)}
                    //   disabled
                    className="bg-gray-100 px-4 py-2 rounded-full text-center w-full"
                  />
                  <button
                    // onClick={() => deleteRoom(index, room._id)}
                    onClick={() => handleDelete(room._id)}
                    className="bg-red-200 text-red-600 flex items-center justify-center p-2 rounded-full hover:bg-red-300 transition"
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-3 w-full">
              <button
                onClick={handleAddRoom}
                className="  bg-blue-600 text-white px-6 py-2 rounded-full w-full text-center"
              >
                Add Room
              </button>
            </div>

            <div className="flex justify-center mt-8 items-center ">
              <button
                onClick={createRoom}
                className="  bg-blue-600 text-white px-6 py-3 rounded-full w-1/2 text-center"
              >
                {roomLoading ? <CircularProgress color="inherit" size={18} /> : 'Save'}
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
